<template>
    <div
        :class="[`btn-social--${button.app}`, { 'btn-social--selected': button.selected }, [displayType]]"
        @click="$emit('click')"
        class="btn-social"
    >
        <div class="btn-social__icon">
            <v-icon :src="button.icon" />
        </div>
        <span class="btn-social__label" v-if="!displayType">{{ button.linkName || button.label }}</span>
    </div>
</template>

<script>
export default {
    name: "SocialBtn",
    props: {
        button: {},
        displayType: String
    }
};
</script>

<style lang="scss" scoped>
.btn-social {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    cursor: pointer;
    padding: 12px 15px;
    width: 100%;
    min-height: auto;
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
    transition: opacity 0.2s ease;
    &:hover {
        opacity: 0.7;
    }
    &.compact,
    &.circle {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        width: 60px;
        .btn-social__icon {
            width: initial;
        }
    }
    &.circle {
        border-radius: 50%;
    }
    &__icon {
        width: 48px;
        display: flex;
        justify-content: center;
        font-size: 28px;
    }
    &--vk,
    &--vk-msg {
        background-color: #4d76a1;
    }
    &--fb {
        background-color: #3b5999;
    }
    &--youtube {
        background-color: #cc181e;
    }
    &--ig {
        background-color: #f00075;
    }
    &--ok {
        background-color: #f7941d;
    }
    &--tk {
        background-color: #000;
    }
    &--tg {
        background-color: #039be5;
    }
    &--wa {
        background-color: #55cd6c;
    }
    &--vb {
        background-color: #7d3daf;
    }
    &--msg {
        background-color: #0084ff;
    }
    &--selected {
        background: #cdcecf;
        cursor: default;
        pointer-events: none;
    }
    &__label {
        text-align: center;
        padding-right: 48px;
        white-space: nowrap;
        overflow: hidden;
        /*text-overflow: ellipsis;*/
    }
    @media (min-width: 769px) {
        &__label {
            text-align: center;
        }
    }
}
</style>
